(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('.r-mobile nav a');
  if (link) link.closest('details').open = false;
});
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') document.querySelectorAll('.r-mobile[open]').forEach(function(menu) { menu.open = false; menu.querySelector('summary').focus(); });
});

  } catch(e) { console.error(e); }
})();
})();
